import React, { useEffect, useState } from 'react';
import { Box, Text, TextButton, ToggleButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/react';
import { Trans } from '@wix/fe-essentials-standalone';
import { useOnboardingPageBi } from '../../hooks/useOnboardingPageBi';

interface Suggestion {
  key: string;
  name: string;
  prompt: string;
}

interface SuggestionButtonsProps {
  prompt: string;
  onSelectPrompt: (prompt: string) => void;
}

export function SuggestionButtons(props: SuggestionButtonsProps) {
  const { onSelectPrompt, prompt } = props;
  const { reportBiClick } = useOnboardingPageBi();
  const { t } = useTranslation();

  const [selectedSuggestion, setSelectedSuggestion] = useState<Suggestion>();

  useEffect(() => {
    if (selectedSuggestion && prompt !== selectedSuggestion.prompt) {
      setSelectedSuggestion(undefined);
    }
  }, [selectedSuggestion, prompt]);

  const [{ suggestions }] = useState(() => ({
    suggestions: [
      {
        key: 'countdown',
        name: t('devibe.onboarding.suggestion.1.title'),
        prompt: t('devibe.onboarding.suggestion.1.full'),
      },
      {
        key: 'additional-fees',
        name: t('devibe.onboarding.suggestion.2.title'),
        prompt: t('devibe.onboarding.suggestion.2.full'),
      },
      {
        key: 'locations',
        name: t('devibe.onboarding.suggestion.3.title'),
        prompt: t('devibe.onboarding.suggestion.3.full'),
      },
    ],
  }));

  const handleSuggestionClick = (suggestion: Suggestion) => {
    reportBiClick({
      buttonName: 'Custom prompt',
      value: suggestion.name,
    });
    setSelectedSuggestion(suggestion);
    onSelectPrompt(suggestion.prompt);
  };

  return (
    <>
      {suggestions.map((suggestion) => (
        <Box paddingLeft="10px" style={{ position: 'relative', bottom: '2px' }}>
          <ToggleButton
            border
            size="tiny"
            shape="pill"
            labelPlacement="end"
            key={suggestion.key}
            labelValue={suggestion.name}
            selected={suggestion.key === selectedSuggestion?.key}
            onClick={() => handleSuggestionClick(suggestion)}
          />
        </Box>
      ))}
    </>
  );
}
